export default __webpack_public_path__ + "static/media/smiley.5bde80f5.svg";